import React, { useEffect, useState } from 'react';
import RaceSetup from './RaceSetup';
// Mantieni RaceLive se lo usi già nel progetto (stile gestito internamente oppure in futuro lo porteremo su App.css)
import RaceLive from './RaceLive';

// Importa App.css a livello globale se non è già caricato in index.js
import '../App.css';

const API_BASE = process.env.REACT_APP_API_BASE || (window.location.protocol === 'https:' ? '' : `http://${window.location.hostname}:5000`);

export default function RacePage() {
  const [raceConfig, setRaceConfig] = useState(null);
  const [raceActive, setRaceActive] = useState(false);

  const handleStartRace = (config) => {
    console.log('[Race] Configurazione ricevuta:', config);
    setRaceConfig(config);
    setRaceActive(true);
  };

  const handleStopRace = () => {
    setRaceActive(false);
    setRaceConfig(null);
  };

  useEffect(() => {
    let cancelled = false;
    const bootstrapExistingRace = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/race/state`);
        if (!res.ok) return;
        const state = await res.json();
        if (!state || state.type !== 'race_snapshot') return;

        let circuitData = state.circuit || null;
        if (state.circuit?.id) {
          try {
            const detailRes = await fetch(`${API_BASE}/api/circuits/${state.circuit.id}`);
            if (detailRes.ok) {
              circuitData = await detailRes.json();
            }
          } catch { /* ignore detail fetch errors */ }
        }

        if (cancelled) return;
        setRaceConfig({
          circuitData,
          totalLaps: state.totalLaps,
          circuit: state.circuit?.id ?? null,
        });
        setRaceActive(true);
      } catch (err) {
        console.error('[Race] Impossibile recuperare lo stato corrente della gara', err);
      }
    };

    bootstrapExistingRace();
    return () => { cancelled = true; };
  }, []);

  if (!raceActive || !raceConfig) {
    // Schermata di setup in stile App.css
    return <RaceSetup onStartRace={handleStartRace} />;
  }

  // Vista live (lasciata com’è; se vuoi, la portiamo allo stesso stile in un secondo step)
  return <RaceLive raceConfig={raceConfig} onStopRace={handleStopRace} />;
}
